import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectCompany, selectCompanyLogoUrl } from '@public-page/store/company';

@Component({
  selector: 'pub-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyInfoComponent {
  $company = this.store.select(selectCompany);
  $logoUrl = this.store.select(selectCompanyLogoUrl);

  constructor(private store: Store) {}
}
